import { observer } from "mobx-react-lite";
import React, { useEffect, useState, useRef } from "react";
import { useStore } from "./app/stores/store";
import "./App.css";
import provinces from "./address/thai_provinces.json";
import districts from "./address/thai_tambons.json";
import amphures from "./address/thai_amphures.json";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { IEmailConfig } from "./app/interfaces/IEmailConfig";
import Select from "react-select";
import logo from "./ricoh-logo.png";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import Swal, { SweetAlertResult } from "sweetalert2";
import { configureStore } from "@reduxjs/toolkit";
const App = () => {
  const [email, setEmail] = useState(String);
  const [emailConfirm, setEmailConfirm] = useState("");
  const [provincesState, setProvinces] = useState("");
  const [districtsState, setDistricts] = useState("");
  const [zipcodesState, setZipcodes] = useState("");
  const [amphuresState, setAmphures] = useState("");
  const [checkbox2, setCheckbox2] = useState(Boolean);
  const [checkbox1, setCheckbox1] = useState(Boolean);
  const [state, setState] = useState({ loading: false });
  const [accept, setAccept] = useState(false);
  const [dealerDisable, setDealerDisable] = useState(true);
  const [captchaString, setCaptchaString] = useState(String);
  const [validated, setValidated] = useState(false);
  const [dealerRequire, setDealerRequire] = useState(false);
  const [datas, setDatas] = useState({});
  const [model, setModel] = useState("");
  const [warrantyEnd, setWarrantyEnd] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);
  const [emailData, setEmailData] = useState({
    serialNumber: "",
    customerName: "",
    buyingType: "",
    dealerName: "",
    address: "",
    moo: "",
    soi: "",
    road: "",
    building: "",
    subDistrict: "",
    district: "",
    province: "",
    zipCode: "",
    tel: "",
    emailAddress: "",
    acceptPolicy: "ไม่ยินยอม",
  });
  const [iMachine, setIMachine] = useState({
    serialNo: "",
    name: "",
  });
  const {
    emailConfigStore: { SendEmailTypeChecking },
    machineConfigStore: { getMachineBySerialNo, UpdateSerial, checkRegistered },
  } = useStore();
  const onSerialChange = (e: any) => {
    setEmailData({
      ...emailData,
      serialNumber: e.target.value.toString(),
    });
    setIMachine({ ...iMachine, serialNo: e.target.value.toString() });
  };
  const onCustomerNameChange = (e: any) => {
    setEmailData({
      ...emailData,
      customerName: e.target.value.toString(),
    });
    setIMachine({ ...iMachine, name: e.target.value.toString() });
  };
  const onConfirmEmailChange = (e: any) => {
    setEmailConfirm(e.target.value)
  };
  const chkBoxChange1 = (e: any) => {
    if (!checkbox1) {
      setCheckbox1(true);
      setCheckbox2(false);
      setDealerDisable(false);
      setDealerRequire(true);
      setEmailData({ ...emailData, buyingType: "ซื้อผ่าน หน้าร้าน" });
    } else {
      setCheckbox1(false);
      setDealerRequire(false);
      setDealerDisable(true);
      setEmailData({ ...emailData, buyingType: "" });
    }
  };
  const chkBoxChange2 = (e: any) => {
    if (!checkbox2) {
      setCheckbox2(true);
      setCheckbox1(false);
      setDealerDisable(false);
      setDealerRequire(true);
      setEmailData({ ...emailData, buyingType: "ซื้อผ่าน Online" });
    } else {
      setCheckbox2(false);
      setDealerRequire(false);
      setDealerDisable(true);
      setEmailData({ ...emailData, buyingType: "" });
    }
  };
  const onChangeAcceptPolicy = (e: any) => {
    if (e.target.checked) {
      setEmailData({ ...emailData, acceptPolicy: "ยินยอม" });
    } else {
      setEmailData({ ...emailData, acceptPolicy: "ไม่ยินยอม" });
    }
  };
  function isValidEmail(email: any) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const chkEmailFormat = (e: any) => {
    if (isValidEmail(e.target.value)) {
      setEmailData({ ...emailData, emailAddress: e.target.value });
    }
  };
  const prepareRequestSubmit = async (sendData: IEmailConfig) => {
    if (accept) {
      if (validateCaptcha(captchaString) === true) {
        const x = await getMachineBySerialNo(iMachine);
        if (x?.primary_con == sendData.customerName) {
          setModel(x?.item_no);
          setWarrantyEnd(x?.sell_end);
          setIsRegister(true);
        } else {
          if (x != null) {
            try {
              requestSubmit(sendData, x?.serial_stat);
            } catch (error) {
              alert(error);
              setState({ ...state, loading: false });
            }
          }
        }
      } else {
        await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Captcha ไม่ถูกต้อง",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          showLoaderOnConfirm: true,
          timer: 5000,
        });
        setState({ ...state, loading: false });
        loadCaptchaEnginge(6);
      }
    }
  };
  const handleSubmit = async (e: any) => {
    setState({ ...state, loading: true });
    if (!dealerRequire) {
      if (
        emailData.serialNumber &&
        emailData.customerName &&
        emailData.address &&
        emailData.subDistrict &&
        emailData.district &&
        emailData.province &&
        emailData.tel && emailData.zipCode &&
        emailData.emailAddress && emailConfirm
      ) {
        if (isValidEmail(emailData.emailAddress)) {
        if (emailData.emailAddress == emailConfirm) {
          prepareRequestSubmit(emailData);
        } else {
          await Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Email Address ไม่ตรงกันโปรดตรวจสอบอีกครั้ง",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            showLoaderOnConfirm: true,
            timer: 5000,
          });
          setState({ ...state, loading: false });
        }
      }
      else
      {
        await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "รูปแบบ Email Address ไม่ถูกต้อง",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          showLoaderOnConfirm: true,
          timer: 5000,
        });
        setState({ ...state, loading: false });
      }
      } else {
        await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "ข้อมูลไม่ครบถ้วน ตรวจสอบข้อมูลอีกครั้ง",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          showLoaderOnConfirm: true,
          timer: 5000,
        });
        setState({ ...state, loading: false });
      }
    } else {
      if (
        emailData.serialNumber &&
        emailData.customerName &&
        emailData.address &&
        emailData.subDistrict &&
        emailData.district &&
        emailData.province &&
        emailData.dealerName &&
        emailData.tel && emailData.zipCode &&
        emailData.emailAddress && emailConfirm
      ) {
        if (isValidEmail(emailData.emailAddress)) {
          if (emailData.emailAddress == emailConfirm) {
            prepareRequestSubmit(emailData);
          } else {
            await Swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Email Address ไม่ตรงกันโปรดตรวจสอบอีกครั้ง",
              showCancelButton: true,
              confirmButtonText: "Confirm",
              showLoaderOnConfirm: true,
              timer: 5000,
            });
            setState({ ...state, loading: false });
          }
        }
        else
        {
          await Swal.fire({
            icon: "warning",
            title: "Warning",
            text: "รูปแบบ Email Address ไม่ถูกต้อง",
            showCancelButton: true,
            confirmButtonText: "Confirm",
            showLoaderOnConfirm: true,
            timer: 5000,
          });
          setState({ ...state, loading: false });
        }
      } else {
        await Swal.fire({
          icon: "warning",
          title: "Warning",
          text: "ข้อมูลไม่ครบถ้วน ตรวจสอบข้อมูลอีกครั้ง",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          showLoaderOnConfirm: true,
          timer: 5000,
        });
        setState({ ...state, loading: false });
      }
    }
  };

  const requestSubmit = async (sendData: IEmailConfig, type: String) => {
    try {
      await Swal.fire({
        icon: "question",
        title: "ยืนยันการส่งข้อมูล",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        showLoaderOnConfirm: true,
        preConfirm: () => submitting(sendData, type),
      });
      setState({ ...state, loading: false });
    } catch (error) {
      alert(error);
      setState({ ...state, loading: false });
    }
  };
  const submitting = async (sendData: IEmailConfig, type: String) => {
    try {
      if (type != "SAL") {
        const response = await SendEmailTypeChecking(sendData);
        if (response) {
          const alertResult: SweetAlertResult = await Swal.fire({
            icon: "success",
            title: "Success",
            text: "Registration Completed",
            showLoaderOnConfirm: true,
            timer: 2500,
          });
          setIsComplete(true);
          setState({ ...state, loading: false });
        }
      } else {
        const response = await UpdateSerial(sendData);
        if (response) {
          const alertResult: SweetAlertResult = await Swal.fire({
            icon: "success",
            title: "Success",
            text: "Registration Completed",
            showLoaderOnConfirm: true,
            timer: 2500,
          });
          setIsComplete(true);
          setState({ ...state, loading: false });
        }
      }
    } catch (error) {
      alert(error);
      setState({ ...state, loading: false });
    }
  };
  const checkSerialRegistration = async (e: any) => {
    if (emailData.customerName != "") {
      const x = await getMachineBySerialNo(iMachine);
      if (
        x?.serial_no == emailData.serialNumber &&
        x?.primary_con == emailData.customerName
      ) {
        setModel(x?.item_no);
          setWarrantyEnd(x?.sell_end);
        setIsRegister(true);
      }
    }
  };
  const checkNameRegistration = async (e: any) => {
    if (emailData.serialNumber != "") {
      const x = await getMachineBySerialNo(iMachine);
      if (
        x?.serial_no == emailData.serialNumber &&
        x?.primary_con == emailData.customerName
      ) {
        setModel(x?.item_no);
          setWarrantyEnd(x?.sell_end);
        setIsRegister(true);
      }
    }
  };
  return (
    <React.Fragment>
      <Col
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card style={{ width: "85%" }}>
          <Card.Header>
            <Row>
              <Col>
                <Card.Title as="h3">Warranty</Card.Title>
              </Col>
              <Col
                style={{
                  textAlign: "right",
                }}
              >
                <img src={logo} width="35%" />
              </Col>
            </Row>
            <Row>
              <Col>
                <Card.Title as="h4">ข้อมูลลงทะเบียนการรับประกัน</Card.Title>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Row hidden={!isRegister}>
              <Col
                style={{
                  textAlign: "right",
                  color: "green",
                  fontSize: "30px",
                }}
              >
                Registered
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      หมายเลขเครื่อง/Serial No
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={onSerialChange}
                      onBlur={checkSerialRegistration}
                      disabled={isRegister}
                      required
                      type="AuthenPassword"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      ชื่อ นามสกุลผู้ซื้อ/Customer Name
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={40}
                      onChange={onCustomerNameChange}
                      onBlur={checkNameRegistration}
                      disabled={isRegister}
                      required
                      type="AuthenPassword"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>

            <Row hidden={!isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>รุ่น/Model</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Control
                      hidden={!isRegister}
                      defaultValue={model}
                      disabled={true}
                      type="text"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>Warranty End</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Control
                      hidden={!isRegister}
                      defaultValue={warrantyEnd}
                      disabled={true}
                      type="text"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>

            <Row hidden={isRegister}>
              <Col md={3}>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Group>
                    <Form.Check
                      custom
                      type="checkbox"
                      id="checkbox1"
                      label="ซื้อผ่านหน้าร้าน"
                      onChange={chkBoxChange1}
                      checked={checkbox1}
                    />
                  </Form.Group>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Check
                      custom
                      type="checkbox"
                      id="checkbox2"
                      label="ซื้อผ่าน Online"
                      onChange={chkBoxChange2}
                      checked={checkbox2}
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>ซื้อจากร้าน/Dealer's Name</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={dealerRequire}>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          dealerName: e.target.value.toString(),
                        })
                      }
                      type="AuthenPassword"
                      size="sm"
                      required={dealerRequire}
                      disabled={dealerDisable}
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={5}>
                <Form>
                  <Form.Group>
                    <Form.Label as="h5">สถานที่ติดตั้งเครื่อง</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      บ้านเลขที่/Address<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={10}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          address: e.target.value.toString(),
                        })
                      }
                      required
                      type="AuthenPassword"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>หมู่/Moo</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Group>
                    <Form.Control
                      maxLength={10}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          moo: e.target.value.toString(),
                        })
                      }
                      type="AuthenPassword"
                      size="sm"
                    />
                  </Form.Group>
                </Form.Group>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>ซอย/Soi</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          soi: e.target.value.toString(),
                        })
                      }
                      required
                      type="SMTPAuthenID"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>ถนน/Road</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          road: e.target.value.toString(),
                        })
                      }
                      required
                      type="SMTPAuthenID"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>อาคาร/Building</Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          building: e.target.value.toString(),
                        })
                      }
                      type="text"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      โทรศัพท์/Tel<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={12}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          tel: e.target.value.toString(),
                        })
                      }
                      required
                      type="text"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>

            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      ตำบล/แขวง/Sub District
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3} style={{ flex: 7, zIndex: 7 }}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          subDistrict: e.target.value.toString(),
                        })
                      }
                      type="text"
                      size="sm"
                      required
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      อำเภอ/เขต/District<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3} style={{ flex: 8, zIndex: 8 }}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={20}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          district: e.target.value.toString(),
                        })
                      }
                      type="text"
                      size="sm"
                      required
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      จังหวัด/Province<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3} style={{ flex: 9, zIndex: 9 }}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          province: e.target.value.toString(),
                        })
                      }
                      maxLength={20}
                      type="text"
                      size="sm"
                      required
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      รหัสไปรษณีย์/Zip Code
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          zipCode: e.target.value.toString(),
                        })
                      }
                      maxLength={5}
                      type="text"
                      size="sm"
                      required
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      Email Address<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={50}
                      onChange={(e) =>
                        setEmailData({
                          ...emailData,
                          emailAddress: e.target.value.toString(),
                        })
                      }
                      type="text"
                      size="sm"
                      required
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form>
                  <Form.Group>
                    <Form.Label>
                      Confirm Email Address
                      <span style={{ color: "red" }}>*</span>
                    </Form.Label>
                  </Form.Group>
                </Form>
              </Col>
              <Col md={3}>
                <Form noValidate validated={validated}>
                  <Form.Group>
                    <Form.Control
                      maxLength={50}
                      onChange={onConfirmEmailChange}
                      required
                      type="text"
                      size="sm"
                    />
                  </Form.Group>
                </Form>
              </Col>
            </Row>
            <Row hidden={isRegister}>
              <Col md={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Col md={10}>
                    <Form.Group controlId="exampleForm.ControlInput1">
                      <Form.Group>
                        <Form.Check
                          custom
                          type="checkbox"
                          id="checkboxAccept"
                          onChange={(e) => setAccept(e.target.checked)}
                          label={
                            //ยอมรับเงื่อนไขการรับประกันคุณภาพของผลิตภัณฑ์ตามที่บริษัทกำหนด อ่านข้อมูลเพิ่มเติมได้ที่ https://www.ricoh.co.th/support/warranty และนโยบายความเป็นส่วนตัวของบริษัท อ่านข้อมูลเพิ่มเติมได้ที่ https://www.ricoh.co.th/privacy-policy
                            <div>
                              
                              ยอมรับเงื่อนไขการรับประกันคุณภาพของผลิตภัณฑ์ตามที่บริษัทกำหนด อ่านข้อมูลเพิ่มเติมได้ที่{" "}
                              <a
                                href="https://www.ricoh.co.th/support/warranty"
                                target="_blank"
                              >
                                https://www.ricoh.co.th/support/warranty
                              </a>{" "}
                              <br/>และนโยบายความเป็นส่วนตัวของบริษัท อ่านข้อมูลเพิ่มเติมได้ที่{" "}
                              <a
                                href="https://www.ricoh.co.th/privacy-policy"
                                target="_blank"
                              >
                                https://www.ricoh.co.th/privacy-policy
                              </a>{" "}
                            </div>
                          }
                        />
                      </Form.Group>
                    </Form.Group>
                  </Col>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Col md={10}>
                    <Form.Group controlId="exampleForm.ControlInput1">
                      <Form.Group>
                        <Form.Check
                          custom
                          type="checkbox"
                          id="checkboxAcceptPolicy"
                          onChange={onChangeAcceptPolicy}
                          label="ยินยอมให้ทางบริษัทสามารถนำข้อมูลไปใช้ในทางการตลาด"
                        />
                      </Form.Group>
                    </Form.Group>
                  </Col>
                </div>
                <div>
                  <div className="container">
                    <div className="form-group">
                      <div
                        className="col mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <LoadCanvasTemplate
                          reloadText="<center>Reload Captcha</center>"
                          reloadColor="red"
                        />
                      </div>
                      <div
                        className="col mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <input
                            onChange={(e) =>
                              setCaptchaString(e.target.value.toString())
                            }
                            maxLength={10}
                            placeholder="Enter Captcha Value"
                            id="user_captcha_input"
                            name="user_captcha_input"
                            type="text"
                          ></input>
                        </div>
                      </div>
                      <div
                        className="col mt-3"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={handleSubmit}
                    type="submit"
                    variant="primary"
                    id="btnSave"
                    disabled={!accept}
                    hidden={isComplete}
                  >
                    {!state.loading ? "Register" : "Loading"}
                  </Button>
                </div>
              </Col>
            </Row>
            <Row hidden={!isComplete || isRegister}>
              <Col
                style={{
                  textAlign: "center",
                  color: "green",
                  fontSize: "30px",
                }}
              >
                Registration Completed
              </Col>
            </Row>
            <Row></Row>
          </Card.Body>
        </Card>
      </Col>
    </React.Fragment>
  );
};
export default observer(App);
